import React, {
  useContext,
  Fragment,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { Radar } from 'react-chartjs-2';
import { SurveyContext } from '../context/surveyContext';

export default function RadarChart() {
  const { survey } = useContext(SurveyContext);
  const [chartData, setChartData] = useState({});

  function Chart() {
    let score = [];
    let comp = [];
    let maxWidthLabel = 20;

    Object.keys(survey.resultInformation).forEach(function (key) {
      score.push(survey.resultInformation[key].percent * 100);
      comp.push(survey.resultInformation[key].title);
    });

    if (window.innerWidth < 800) {
      maxWidthLabel = 10;
    }

    comp.forEach((element, i) => {
      comp[i] = formatLabel(element, maxWidthLabel)
    });

    function formatLabel(str, maxwidth){
      var sections = [];
      var words = str.split(" "); 
      var temp = "";
  
      words.forEach(function(item, index){
          if(temp.length > 0)
          {
              var concat = temp + ' ' + item;
  
              if(concat.length > maxwidth){
                  sections.push(temp);
                  temp = "";
              } 
              else{
                  if(index === (words.length-1))
                  {
                      sections.push(concat);
                      return;
                  }
                  else{
                      temp = concat;
                      return;
                  }
              }
          }
  
          if(index == (words.length-1))
          {
              sections.push(item);
              return;
          }
  
          if(item.length < maxwidth) {
              temp = item;
          }
          else {
              sections.push(item);
          }
  
      });
  
      return sections;
    }

    // let color = '';

    // if (score < 33) {
    //   color = '#e52729';
    // } else if (score >= 33 && score < 66) {
    //   color = '#ffba2a';
    // } else {
    //   color = '#71874d';
    // }

    setChartData({
      labels: comp,
      datasets: [
        {
          label: 'Kompetens',
          fill: false,
          borderColor: '#666666',
          pointBackgroundColor: '#666666',
          data: score,
          borderWidth: 1,
        },
      ],
    });
  }

  useEffect(() => {
    // Run on mount
    Chart();

    // Run on unmount
    return () => {
      console.log('unmounting');
    };
  }, [survey]);

  return (
    <Fragment>
      {survey && (
        <section className='result__radar-section print' id='radar'>
          <div className='result__radar-section-text'>
            <h2>{survey.title_radar_chart}</h2>
            <p>{survey.description_radar_chart}</p>
          </div>
          <div className='radar-container'>
            <Radar
              data={chartData}
              options={{
                layout: {
                  padding: {
                    left: 0,
                    top: -50,
                    right: 0,
                    bottom: 0,
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                    labels: {
                      font: {
                        size: 18,
                        lineHight: 23,
                      },
                    },
                  },
                  title: {
                    display: false,
                  },
                },
                scales: {
                  r: {
                    angleLines: {
                      display: false,
                    },
                    pointLabels: {
                      font: () => ({ size: window.innerWidth < 800 ? 13 : 18 }),
                    },
                    suggestedMin: 0,
                    suggestedMax: 100,
                    ticks: {
                      stepSize: 25,

                      callback: function () {
                        return '';
                      },
                      backdropColor: 'rgba(0, 0, 0, 0)',
                    },
                  },
                  grid: {
                    display: false,
                  },
                },
              }}
            />
          </div>
        </section>
      )}
    </Fragment>
  );
}
